
// const OSS = require('ali-oss');//
import emojiPicker from "@/components/emojiPicker/emojiPicker.vue";
import atBox from "@/components/at/atBox.vue";
import verification from "@/components/verificationCode/verification.vue";
import { canAuthorEditContent } from "@/utils/contentEdit";
export default {
  name: "index",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "releaseworks",
      meta: [
        {
          name: "keywords",
          content: "releaseworks",
        },
        {
          name: "description",
          content: "users can publish their own atlas or video",
        },
      ],
      script: [{ src: "https://gosspublic.alicdn.com/aliyun-oss-sdk-6.16.0.min.js" }], //cdn方式引入ali-oss
    };
  },
  middleware: "userAuth", //中间件页面登录鉴权
  components: { emojiPicker, atBox, verification },
  data() {
    return {
      type: 1, //1是发布图片 2是发布视频
      productValue: "", //当前选中产品
      activityList: [], //活动列表
      activityValue: "", //当前选中活动
      editId: "", // 有值表示编辑已有作品
      lockedActivityId: "", // 编辑时已参加的活动 id，来自 edit_info.activityId
      activityLocked: false, // 已参加活动时禁止改选其他活动
      editAppointUid: "", // 编辑预填的 @ 人，用户未重新 @ 时原样提交
      editContentVideo: "", // 预填的视频地址，只认 edit_info.thumb，未更换时沿用 video_time
      editVideoTime: "", // 预填的视频时长
      tag_list: [], //标签列表
      voteGoods: [], //产品列表
      rand_code: "", //上传随机码
      imageUrl: "",
      serverResultUrl: "", //视频的封面图
      fileList: [], // 图集/视频封面的文件列表
      videoFileList: [], // 视频选择列表，不和封面共用，避免编辑时被 limit 拦住换不了视频
      atlasList: [],
      cover: "",
      video: "",
      percentage: 0,
      uploading: false, //是否上传ing
      comments: "",
      coverTips: false, //未上传图片提示语
      tagsTips: false, //未上传标签提示语
      vedioTips: false, //未上传视频提示语
      vedioCoverTips: false, //未上传视频封面提示
      submitLoading: false, //提交loading
      ossConfig: {}, //ali-oss配置
      videoFrame: "", //视频第一帧
      successPrompt: false, //上传成功后暂不支持预览的提示遮罩
      selectionStart: "", //光标位置
      // atLoading: true,
      userAts: [],
      headers: {
        // 指定上传文件的类型。
        // 'Content-Type': 'video/mp4',
        // 指定该Object被下载时网页的缓存行为。
        // 'Cache-Control': 'no-cache',
        // 指定该Object被下载时的名称。
        // 'Content-Disposition': 'oss_download.txt',
        // 指定该Object被下载时的内容编码格式。
        // 'Content-Encoding': 'UTF-8',
        // 指定过期时间。
        // 'Expires': 'Wed, 08 Jul 2022 16:57:01 GMT',
        // 指定Object的存储类型。
        // 'x-oss-storage-class': 'Standard',
        // 指定Object的访问权限。
        // 'x-oss-object-acl': 'private',
        // 设置Object的标签，可同时设置多个标签。
        // 'x-oss-tagging': 'Tag1=1&Tag2=2',
        // 指定CopyObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        // 'x-oss-forbid-overwrite': 'true',
      },
      fileRaw: undefined, //源文件
      captchaCode: "",
    };
  },

  async asyncData({ $global, query }) {
    let type = "";
    const res = await $global.releaseConfigure();
    res.data.tag_list.forEach((item) => {
      item.active = false;
      item.bgColor = "";
    });
    query.type && query.type != 1 ? (type = 2) : (type = 1);
    return {
      activityList: res.data.activityList,
      tag_list: res.data.tag_list,
      voteGoods: res.data.voteGoods,
      rand_code: res.data.rand_code,
      type: type,
    };
  },
  watchQuery: ["type"],

  mounted() {
    this.$route.query.type && this.$route.query.type != 1 ? (this.type = 2) : "";
    document.addEventListener("visibilitychange", this.handleVisiable);
    this.loadEditSource();
  },
  destroyed() {
    document.removeEventListener("visibilitychange", this.handleVisiable);
  },
  methods: {
    /** 编辑已有作品时，用 /works/edit_info 预填正文、图片/视频、封面和标签 */
    async loadEditSource() {
      const id = Number(this.$route.query.id);
      if (!id) {
        return;
      }
      this.editId = String(id);
      const res = await this.$global.worksEditInfo({ id });
      if (res.code !== 200 || !res.data) {
        this.$message.error((res && res.msg) || this.$t("page.UNKNOWN_ERROR"));
        this.$router.replace({ path: `/gallery/${id}` });
        return;
      }
      const data = res.data;
      if (!canAuthorEditContent(data.status)) {
        this.$message.error(this.$t("page.UNKNOWN_ERROR"));
        this.$router.replace({ path: `/gallery/${id}` });
        return;
      }
      if (data.type === 1 || data.type === 2) {
        this.type = data.type;
      }
      this.comments = data.content || "";
      this.productValue = data.goods_id;
      const activityId = data.activityId;
      // 已参加活动（activityId > 0）时锁定，编辑不能改选
      this.activityLocked = Number(activityId) > 0;
      this.lockedActivityId = this.activityLocked ? activityId : "";
      if (this.activityLocked) {
        const matched = (this.activityList || []).find(
          (item) => Number(item.id) === Number(activityId)
        );
        this.activityValue = matched ? matched.id : activityId;
      }
      this.editAppointUid = data.appoint_uid || "";
      this.applySelectedTags(data.tags);
      if (this.type === 1) {
        const coverUrl = data.thumb || "";
        const images = Array.isArray(data.images) ? data.images : [];
        if (coverUrl) {
          this.cover = { virtualUrl: coverUrl, realityUrl: coverUrl };
          this.coverTips = false;
        }
        this.atlasList = images
          .filter((url) => url && url !== coverUrl)
          .map((url) => ({ virtualUrl: url, realityUrl: url }));
      }
      if (this.type === 2) {
        // 视频作品地址只认 thumb，封面仍用 thumb_video
        const videoUrl = data.thumb || "";
        this.editContentVideo = videoUrl;
        this.editVideoTime = data.video_time || "";
        if (videoUrl) {
          this.video = {
            realityUrl: videoUrl,
            virtualUrl: videoUrl,
          };
          this.successPrompt = true;
          this.vedioTips = false;
        }
        if (data.thumb_video) {
          this.serverResultUrl = data.thumb_video;
          this.videoFrame = data.thumb_video;
          this.fileList = [{ name: "cover", url: data.thumb_video }];
          this.vedioCoverTips = false;
        }
      }
    },
    /** 按 edit_info.tags 的标签名勾选发布页预设标签 */
    applySelectedTags(tagList) {
      const names = Array.isArray(tagList) ? tagList : [];
      (this.tag_list || []).forEach((item) => {
        this.$set(item, "active", names.includes(item.tag_name));
      });
    },
    /**
     * 编辑走 /works/edit，新建仍走 /works/upload。
     * 编辑请求的 id 为整数，goods_id 与 activityId 为字符串。
     */
    requestWorks(sourceData) {
      if (!this.editId) {
        return this.$global.worksUpload(sourceData);
      }
      const activityId = this.activityLocked ? this.lockedActivityId : this.activityValue;
      return this.$global.worksEdit({
        id: Number(this.editId),
        imagePath: sourceData.imagePath,
        tag: sourceData.tag,
        coverImagePath: sourceData.coverImagePath,
        content: sourceData.content,
        latitude_longitude: "",
        ll_name: "",
        appoint_uid: this.userAts.length
          ? JSON.stringify(this.userAts)
          : this.editAppointUid || "",
        type: String(sourceData.type),
        goods_id:
          this.productValue == null || this.productValue === ""
            ? ""
            : String(this.productValue),
        activityId:
          activityId == null || activityId === "" ? "" : String(activityId),
        thumb_video: sourceData.thumb_video || "",
        video_time: sourceData.video_time || "",
        rand_code: this.rand_code,
        check_str: this.captchaCode || "",
      });
    },
    handleVisiable(e) {
      switch (e.target.visibilityState) {
        case "prerender":
          break;
        case "hidden":
          break;
        case "visible":
          console.log(
            this.$refs.verification.dialogVisible,
            "this.$refs.verification.dialogVisible"
          );
          if (this.$refs.verification.dialogVisible) {
            this.$refs.verification.getCaptcha();
          }
          break;
      }
    },
    async aliOssConfig() {
      //获取oss配置
      let res = await this.$global.multiplefile_token();
      res.code == 200 ? (this.ossConfig = res.data) : {};
    },
    emoji_click(value) {
      this.comments += value;
    },
    async getReleaseConfigure() {
      //获取标签和活动
      let res = await this.$global.releaseConfigure();
      console.log(res);
      res.data.tag_list.forEach((item) => {
        item.active = false;
        item.bgColor = "";
      });
      res.code == 200
        ? ((this.activityList = res.data.activityList),
          (this.tag_list = res.data.tag_list),
          (this.voteGoods = res.data.voteGoods),
          (this.rand_code = res.data.rand_code))
        : "";
    },
    checkTag(index) {
      //tag点击事件
      if (!this.tag_list[index].active) {
        let sum = 0;
        this.tag_list.forEach((item) => {
          item.active == true ? (sum += 1) : "";
        });
        if (sum < 6) {
          this.tag_list[index].active = true;
          //设置动态颜色
          // let colorArr = ['linear-gradient(88deg, #FEEAF5 0%, #FFEFE7 100%)',
          //     'linear-gradient(88deg, #E5F5FD 0%, #E5FEF7 100%)',
          //     'linear-gradient(88deg, #EDF9EE 0%, #FCFEE4 100%)'
          // ]

          // let idx = parseInt(Math.random() * 3)
          this.tag_list[index].bgColor = "#F9874F";
          this.tagsTips = false;
        }
      } else {
        this.tag_list[index].active = false;
      }
    },
    handleRemove(index) {
      //图集删除
      this.atlasList.splice(index, 1);
    },
    handleWorkCoverRemove(file, fileList) {
      //删除作品封面图
      this.atlasList.shift();
    },
    frontCover(index) {
      //替换封面图
      [this.cover, this.atlasList[index]] = [this.atlasList[index], this.cover];
    },
    onError(err, file, fileList) {
      //上传失败
      this.$message.error(this.$t('page.UPLOAD_FAILED_RETRY'));
      this.uploading = false;
    },
    async aliOssUpload(file, contentType) {
      //使用ali-oss上传文件
      //file是文件，type是文件类型  contentType 1是封面图 2是八宫格图片 3是视频
      try {
        // 获取OSS配置
        await this.aliOssConfig();
        const resultOss = await this.$ossUpload(file.raw, this.ossConfig, {
          progress: (p, cpt, res) => {
            console.log(parseInt(p * 100));
            this.percentage = parseInt(p * 100);
          },
        });

        console.log(resultOss);
        this.fileRaw = file.raw;
        //防止重复命名
        const result = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
        });
        const log = await this.$global.uploadLog({
          url: result.data,
          log_type: 1,
          rand_code: this.rand_code,
        });
        result.code == 200 ? this.successfullyUploaded(file, result, contentType) : "";
      } catch (err) {
        console.error("Upload failed:", err);
        this.uploadloading = false;
        if (this.type == 2) this.videoFileList = [];
        this.$message.error(this.$t('page.UPLOAD_FAILED'));
      }
    },
    async successfullyUploaded(file, res, contentType) {
      //oss上传成功处理
      this.uploading = false;
      if (this.type == 1) {
        //上传图片的成功回调 默认展示内存地址 提高用户体验 contentType 1是封面图 2是八宫格图片 3是视频
        this.percentage = 100;
        if (contentType == 1) {
          res.code == 200
            ? (this.cover = {
                realityUrl: res.data,
                virtualUrl: URL.createObjectURL(file.raw),
              })
            : "";
          this.coverTips = false;
        }
        if (contentType == 2) {
          res.code == 200
            ? this.atlasList.push({
                realityUrl: res.data,
                virtualUrl: URL.createObjectURL(file.raw),
              })
            : "";
        }
        if (contentType == 3) {
          res.code == 200
            ? (this.video = {
                realityUrl: res.data,
                virtualUrl: URL.createObjectURL(file.raw),
              })
            : "";
          this.vedioTips = false;
        }
        this.fileList = []; //清空文件列表
        setTimeout(() => {
          this.uploading = false;
          this.percentage = 0;
        }, 500);
      } else {
        //上传视频的回调
        this.findvideocover(file);
        this.vedioTips = false;
        this.videoFileList = []; // 只清视频选择，封面 fileList 留着
        setTimeout(() => {
          this.uploading = false;
          this.percentage = 0;
        }, 500);
        this.video = { realityUrl: res.data, virtualUrl: URL.createObjectURL(file.raw) };
      }
    },
    beforeAvatarUpload(file, type, contentType) {
      //格式校验
      //type==1 是上传图片 type==2 是上传视频 type=='3' 则是上传视频封面
      //如果上传的是视频的封面图则不打开.upload-mask进度条遮罩

      if (type == 1 || type == 3) {
        //上传图片之前的验证 格式必须是 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'HEIC' 大小不超过5MB
        let index = file.name.lastIndexOf(".");
        let extn = file.name.substr(index + 1);
        let isFormat =
          ["png", "jpg", "jpeg", "gif", "bmp", "HEIC"].indexOf(extn.toLowerCase()) != -1;
        const isLt5M = file.size / 1024 / 1024 < 20;
        if (!isFormat) {
          this.$message.error(this.$t('page.UPLOAD_IMAGE_FORMAT_ERROR'));
        }
        if (!isLt5M) {
          this.$message.error(this.$t('page.UPLOAD_IMAGE_SIZE_30MB'));
        }
        if (isFormat && isLt5M) {
          type == 1 ? (this.uploading = true) : "";
          type == 1 ? this.aliOssUpload(file, contentType) : "";
          return true;
        } else {
          this.fileList = [];
          return false;
        }
      }
      if (type == 2) {
        //上传视频之前的验证 格式必须是 "avi", "flv", "mp4", "3gp", "wmv", "rmvb", "mpeg", "mov" 大小不超过100MB
        let index = file.name.lastIndexOf(".");
        let extn = file.name.substr(index + 1);
        let isVideoFormat = ["mp4", "ogg", "webm"].indexOf(extn.toLowerCase()) != -1;
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isVideoFormat) {
          this.$message.error(this.$t('page.UPLOAD_VIDEO_FORMAT_ERROR'));
        }
        if (!isLt100M) {
          this.$message.error(this.$t('page.UPLOAD_VIDEO_SIZE_100MB'));
        }
        if (isVideoFormat && isLt100M) {
          this.uploading = true;
          this.aliOssUpload(file, contentType);
          return true;
        } else {
          this.videoFileList = [];
          return false;
        }
      }
    },
    onprocess(event, file, fileList) {
      //文件上传中的钩子
      console.log(parseInt(file.percentage.toFixed(0), 10));
      this.percentage = parseInt(file.percentage.toFixed(0), 10);
    },
    uploadVideo() {
      // 先清空已选文件，否则 limit=1 时再次选择不会触发
      const input = document.querySelector(".uploaderVideo input");
      if (!input) return;
      this.videoFileList = [];
      input.value = "";
      input.click();
    },
    uploadAtlasCover() {
      //上传封面
      document.querySelector(".uploaderCover input").click();
    },
    uploadAtlas() {
      //八宫格图集上传方法
      document.querySelector(".uploader input").click();
    },
    format(percentage) {
      //通过 format 属性来指定进度条文字内容
      return "";
    },
    findvideocover(file) {
      //视频封面截图
      let that = this;
      let video = document.createElement("video");
      video.setAttribute("crossOrigin", "anonymous"); //处理跨域
      video.setAttribute("src", URL.createObjectURL(file.raw));
      video.currentTime = 1;
      video.addEventListener("loadeddata", function () {
        let canvas = document.createElement("canvas");
        //使用视频的宽高作为canvas、预览图的宽高
        let width = 800;
        let height = 500;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
        that.videoFrame = canvas.toDataURL("image/jpeg"); //base64图片
        that.successPrompt = true;
      });
    },
    beforeRelease() {
      this.release();
    },
    triggerMethod() {
      this.release();
    },
    async release() {
      //发布作品

      let tag = [];
      this.tag_list.forEach((item) => {
        item.active == true ? tag.push(item.tag_name) : "";
      });
      if (this.type == 1) {
        //type 1是上传图片

        if (this.cover == "") {
          //判断是否上传了封面图
          this.coverTips = true;
          return false;
        }
        if (tag.length == 0) {
          //判断是否选择了标签
          this.tagsTips = true;
          return false;
        }
        this.submitLoading = true;
        let sourceData = {
          imagePath: [this.cover, ...this.atlasList]
            .map((item) => {
              return item.realityUrl;
            })
            .join(),
          tag: tag.join(","),
          coverImagePath: this.cover.realityUrl,
          content: this.comments,
          latitude_longitude: "",
          ll_name: "",
          id: this.editId || "",
          appoint_uid: "",
          type: "1",
          class_id: "1",
          privacy: "1",
          goods_id: this.productValue,
          activityId: this.editId ? this.lockedActivityId : this.activityValue,
          thumb_video: "",
          video_time: "",
          rand_code: this.rand_code,
          appoint_uid: JSON.stringify(this.userAts),
          check_str: this.captchaCode,
        };
        let res = await this.requestWorks(sourceData);
        console.log(res);
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$refs.verification.changeVisible(false);
          this.$refs.verification.captchaCode = "";
          const worksId = (res.data && res.data.works_id) || this.editId;
          // 编辑不再打首次发布埋点
          if (!this.editId) {
            this.$track("post_published", {
              content_id: worksId,
              content_type: 1,
              content_tag: tag.join(","),
              item_name:
                this.voteGoods.find((item) => item.id == this.productValue)?.title || "",
              item_linkid: this.productValue,
              event_id: this.activityValue,
              event_name:
                this.activityList.find((item) => item.id == this.activityValue)?.title ||
                "",
              item_link:
                this.voteGoods.find((item) => item.id == this.productValue)?.buy_url || "",
            });
          }
          setTimeout(() => {
            this.$router.push({
              path: `/gallery/${worksId}`,
            });
          }, 1000);
        } else if (res.code == 509) {
          this.submitLoading = false;
          this.$refs.verification.changeVisible(true);
          this.$refs.verification.getCaptcha();
          this.$message({
            showClose: true,
            message: this.$t('page.ENTER_VERIFY_CODE'),
            type: "error",
          });
        } else {
          this.$refs.verification.getCaptcha();
          this.$refs.verification.captchaCode = "";
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
        this.captchaCode = "";
      } else {
        //type 2 是上传视频
        let audioElement = new Audio(this.video.virtualUrl);
        let self = this;
        let result;
        // if (tag.length == 0 || this.serverResultUrl == '' || this.productValue == '' || this.activityValue == '' || this.video == '') {
        //     this.$message({
        //         message: 'Please enter content',
        //         type: 'warning'
        //     });
        //     return
        // }
        if (this.video == "") {
          //判断是否上传了视频
          this.vedioTips = true;
          return false;
        }
        if (this.serverResultUrl == "") {
          //判断是否上传了视频封面
          this.vedioCoverTips = true;
          return false;
        }
        if (tag.length == 0) {
          //判断是否选择了标签
          this.tagsTips = true;
          return false;
        }
        this.submitLoading = true;
        /** 提交视频作品；未更换视频时直接使用 edit_info 返回的 video_time */
        const submitVideoWork = async (videoTime) => {
          let sourceData = {
            imagePath: self.video.realityUrl,
            tag: tag.join(","),
            coverImagePath: self.serverResultUrl,
            content: self.comments,
            latitude_longitude: "",
            ll_name: "",
            id: self.editId || "",
            appoint_uid: "",
            type: "2",
            class_id: "1",
            privacy: "1",
            goods_id: self.productValue,
            activityId: self.editId ? self.lockedActivityId : self.activityValue,
            thumb_video: self.serverResultUrl,
            video_time: videoTime,
            rand_code: self.rand_code,
            appoint_uid: JSON.stringify(self.userAts),
            check_str: self.captchaCode,
          };
          let res = await self.requestWorks(sourceData);
          console.log(res);
          if (res.code === 200) {
            self.$message({
              showClose: true,
              message: res.msg,
            });
            const worksId = (res.data && res.data.works_id) || self.editId;
            if (!self.editId) {
              self.$track("post_published", {
                content_id: worksId,
                content_type: 2,
                content_tag: tag.join(","),
                item_name:
                  self.voteGoods.find((item) => item.id == self.productValue)?.title || "",
                item_linkid: self.productValue,
                event_id: self.activityValue,
                event_name:
                  self.activityList.find((item) => item.id == self.activityValue)?.title ||
                  "",
                item_link:
                  self.voteGoods.find((item) => item.id == self.productValue)?.buy_url ||
                  "",
              });
            }
            setTimeout(() => {
              self.$router.push({
                path: `/gallery/${worksId}`,
              });
            }, 1000);
          } else if (res.code == 509) {
            self.submitLoading = false;
            self.$refs.verification.changeVisible(true);
            self.$refs.verification.getCaptcha();
          } else {
            self.$refs.verification.getCaptcha();
            self.$refs.verification.captchaCode = "";
            self.$message({
              showClose: true,
              message: "Error",
              type: "error",
            });
          }
          self.captchaCode = "";
        };
        if (
          this.editId &&
          this.video.realityUrl === this.editContentVideo &&
          this.editVideoTime
        ) {
          await submitVideoWork(this.editVideoTime);
          return;
        }
        audioElement.addEventListener("loadedmetadata", async function () {
          // 视频时长值的获取要等到这个匿名函数执行完毕才产生
          result = audioElement.duration; //得到时长为秒，小数，182.36
          await submitVideoWork((result * 1000).toFixed(2));
        });
      }
    },
    enterFocus(e) {
      console.log(e.srcElement);
      this.selectionStart = e.srcElement.selectionStart;
      console.log(this.selectionStart);
    },
    // keydown触发事件(按下键盘时候触发)
    enterEv(e) {
      const { keyCode, code } = e;
    },
    // input变化
    enterInput(e) {
      let that = this;
      this.userAts.forEach(function (item, i) {
        console.log(
          that.comments,
          that.comments.includes("@" + item.nickname),
          item,
          "循环"
        );
        if (!that.comments.includes("@" + item.nickname)) {
          that.userAts.splice(i, 1);
        }
      });
      console.log(this.userAts);
    },
    getAt(atValue, userAt, selectionVal) {
      this.comments = atValue;
      this.userAts = userAt;
      this.selectionStart = selectionVal;
    },
    preview() {
      //预览
      //标签
      let self = this;
      let tag = [];
      this.tag_list.forEach((item) => {
        item.active == true ? tag.push(item.tag_name) : "";
      });
      let previewData = {
        imagePath:
          this.type == 1
            ? [this.cover, ...this.atlasList]
                .map((item) => {
                  return item.realityUrl;
                })
                .join()
            : self.video.realityUrl,
        tag: tag.join(","),
        content: this.comments,
        type: this.type,
        goods: this.voteGoods.find(function (item) {
          if (item.id == self.productValue) {
            return item;
          }
        }),
        activity: this.activityList.find(function (item) {
          if (item.id == self.activityValue) {
            return item;
          }
        }),
        face_url: this.$store.state.userInfo.face_url,
        nickname: this.$store.state.userInfo.userInfo.nickname,
        coverImagePath: self.serverResultUrl,
      };
      localStorage.setItem("previewWord", JSON.stringify(previewData));
      let routeData = this.$router.resolve({ path: "/preview/work" });
      window.open(routeData.href, "_blank");
    },
    async uploadSectionFile(param) {
      console.log(param);
      let { file } = param;
      try {
        // 获取OSS配置
        await this.aliOssConfig();
        const resultOss = await this.$ossUpload(file, this.ossConfig, {
          progress: (p, cpt, res) => {
            param.onProgress({ percent: parseInt(p * 100) });
          },
        });
        console.log(resultOss);
        param.onSuccess(resultOss);
        this.imageUrl = URL.createObjectURL(file);
        this.vedioCoverTips = false;
        this.fileRaw = file;
        //防止重复命名
        const result = await this.$global.ossUrlFind({
          oss_url: `https://xfanstemp.oss-us-west-1.aliyuncs.com${resultOss.name}`,
        });
        this.serverResultUrl = result.data;
        const log = await this.$global.uploadLog({
          url: result.data,
          log_type: 1,
          rand_code: this.rand_code,
        });
      } catch (err) {
        console.error("Upload failed:", err);
        this.uploadloading = false;
        this.$message.error(this.$t('page.UPLOAD_FAILED'));
      }
    },
  },
};
